import * as React from "react";
import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { Text } from "src/library/components/Text";
import { INotification } from "src/core/notifications/api/notifications.api";

import { AudienceCell } from "./notifications/audienceCell";

export interface INotificationTableColumns {
  action: (info: CellContext<INotification, unknown>) => React.ReactNode,
  terminology: ITerminology,
  excludedColumns?: CustomerUserDropColumnsPicked[],
}

type CustomerUserDropColumnsPicked = keyof AvailableNotificationTableColumns;

interface AvailableNotificationTableColumns{
  //notification subject
  subject: ColumnDef<INotification, unknown>,
  //notification audience in groups of type global, customer, branch
  audience: ColumnDef<INotification, unknown>,
  sentAt: ColumnDef<INotification, unknown>,
  sentBy: ColumnDef<INotification, unknown>,
  actions: ColumnDef<INotification, unknown>,
}

/** columns for drops the are assigned to a user inc selecting feature*/
export const getNotificationTableColumns = (params: INotificationTableColumns) => {
  const customColumnHelper = customCreateColumnHelper<INotification>();
  const columnHelper = createColumnHelper<INotification>();

  const allColumns: AvailableNotificationTableColumns = {

    subject: customColumnHelper.standardTextColumn(columnHelper, "title", {
      header: "Subject",
      size: 200
    }),

    //shows a heading of recipient type and a list of recipients the notification has been sent to.
    audience: customColumnHelper.standardTextColumn(columnHelper, "notificationRecipients", {
      header: "Audience",
      enableColumnFilter: false,
      enableSorting: false,
      cell: info => {
        return (
          <AudienceCell
            key={info.row.original.id}
            recipients={info.row.original.notificationRecipients}
            terminology={params.terminology}
          />
        );
      }
    }),
    sentAt: customColumnHelper.dateColumn(columnHelper, "createdAt", { header: "Sent At" }),
    sentBy: customColumnHelper.standardTextColumn(columnHelper, "sentByUser", {
      enableSorting: false,
      enableColumnFilter: false,
      header: "Sent By Admin",
      cell: info => {
        return (
          <Text>
            {info.row.original.sentByUser?.email}
          </Text>
        );
      }
    }),

    actions: customColumnHelper.actionColumn(columnHelper, params.action, {})
  };

  if (params.excludedColumns) {
    const result = allColumns;

    for (const col of params.excludedColumns) {
      delete result[ col ];
    }

    return Object.values(result);
  } else {
    return Object.values(allColumns);
  }
};
